if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.minicart = document.querySelector("mini-cart");
        this.quickViewDrawer = this.closest("quick-view-drawer");
        this.eventContext = this.form.dataset.eventContext;
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(event) {
        event.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) {
          return;
        }

        this.handleErrorMessage();

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        this.querySelector(".button-overlay-spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.minicart) {
          formData.append(
            "sections",
            this.minicart.getSectionsToRender().map((section) => section.section),
          );
        }
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);
              this.minicart?.updateSectionContents();
              return;
            }

            this.minicart?.renderContents(response);

            if (!this.minicart || window.themeSettings.redirectToCart) {
              location.href = window.routes.cart_url;
            } else {
              // TradeTidy: don't auto-open the cart drawer on add. The drawer's
              // contents and the header cart count are already refreshed by
              // renderContents() above; give the shopper an inline "Added" cue
              // on the button instead. (The kit builder still opens the drawer
              // from custom-bundle.js.)
              if (this.quickViewDrawer) {
                this.quickViewDrawer.close();
              }
              this.showAddedFeedback(submitButton);
            }

            const event = new CustomEvent("cart:item-add", {
              detail: {
                items: [response],
                context: this.eventContext,
              },
            });
            document.dispatchEvent(event);

            publish(PUB_SUB_EVENTS.cartItemAdd, {
              source: this.eventContext,
              items: [response],
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            this.querySelector(".button-overlay-spinner").classList.add("hidden");
          });
      }

      showAddedFeedback(button) {
        if (!button) return;
        const target = button.querySelector("span:not(.spinner-xs):not(.button-overlay-spinner)");
        if (!target || !target.textContent.trim()) {
          // No text label to swap (icon-only button): just flash the state class.
          button.classList.add("is-added");
          setTimeout(() => button.classList.remove("is-added"), 1800);
          return;
        }
        if (button.dataset.ttAddedTimer) {
          clearTimeout(Number(button.dataset.ttAddedTimer));
        } else {
          button.dataset.ttOriginalLabel = target.textContent;
        }
        target.textContent = "Added ✓";
        button.classList.add("is-added");
        button.dataset.ttAddedTimer = String(
          setTimeout(() => {
            target.textContent = button.dataset.ttOriginalLabel || "Add to cart";
            button.classList.remove("is-added");
            delete button.dataset.ttAddedTimer;
            delete button.dataset.ttOriginalLabel;
          }, 1800),
        );
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form-error-message-wrapper");
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(".product-form-error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
